import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule, TabsModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../../shared/shared/shared.module';
import { DestinationAddDestinationModalComponent } from './destination-add-destination-modal.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { CountryCodeService } from '../../../../services/country-code/country-code.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    GooglePlaceModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
  ],
  providers: [
    CountryCodeService,
  ],
  declarations: [DestinationAddDestinationModalComponent],
  exports: [DestinationAddDestinationModalComponent]
})
export class DestinationAddDestinationModalModule {
}
